<div class="form-ui" [ngClass]="{'container': (isSmallScreen | async)}">
  <mat-card>
    <mat-card-title>New prescription</mat-card-title>
    <mat-stepper linear #stepper [orientation]="(stepperOrientation | async)!">
      <mat-step [stepControl]="customerDetailsForm" [editable]="isEditable">
        <ng-template matStepLabel>Fill out your details</ng-template>
        <form autocomplete="off" [formGroup]="customerDetailsForm" class="mt-2">
          <div class="row">
            <div class="col-md-6">
              <p>
                <mat-form-field appearance="outline">
                  <mat-label>Title</mat-label>
                  <mat-select data-testid="customer-title" formControlName="title">
                    <mat-option value="Mr">Mr</mat-option>
                    <mat-option value="Mrs">Mrs</mat-option>
                    <mat-option value="Miss">Miss</mat-option>
                  </mat-select>
                  @if (customerDetailsForm.get('title')?.invalid) {
                    <mat-error>
                      Title is required
                    </mat-error>
                  }
                </mat-form-field>
              </p>
              <p>
                <mat-form-field appearance="outline">
                  <mat-label>Your Initials</mat-label>
                  <input data-testid="customer-initials" formControlName="initials" matInput placeholder="Initials">
                  @if (customerDetailsForm.get('initials')?.invalid) {
                    <mat-error>
                      Initials are required
                    </mat-error>
                  }
                </mat-form-field>
              </p>
              <p>
                <mat-form-field appearance="outline">
                  <mat-label>Your First Name</mat-label>
                  <input data-testid="customer-first-name" formControlName="firstName" matInput placeholder="First name">
                  @if (customerDetailsForm.get('firstName')?.invalid) {
                    <mat-error>
                      First Name is required
                    </mat-error>
                  }
                </mat-form-field>
              </p>
              <p>
                <mat-form-field appearance="outline">
                  <mat-label>Your Last Name</mat-label>
                  <input data-testid="customer-last-name" formControlName="lastName" matInput placeholder="Last Name">
                  @if (customerDetailsForm.get('lastName')?.invalid) {
                    <mat-error>
                      Last Name is required
                    </mat-error>
                  }
                </mat-form-field>
              </p>
              <p>
                <mat-form-field appearance="outline">
                  <mat-label>Your Gender</mat-label>
                  <mat-select data-testid="customer-gender" formControlName="gender">
                    <mat-option value="male">Male</mat-option>
                    <mat-option value="female">Female</mat-option>
                    <mat-option value="other">Other</mat-option>
                  </mat-select>
                  @if (customerDetailsForm.get('gender')?.invalid) {
                    <mat-error>
                      Gender is required
                    </mat-error>
                  }
                </mat-form-field>
              </p>
              <p>
                <mat-form-field appearance="outline">
                  <mat-label>Date of birth</mat-label>
                  <input data-testid="customer-date-of-birth" formControlName="dateOfBirth" matInput [matDatepicker]="picker">
                  <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                  <mat-datepicker #picker></mat-datepicker>
                  @if (customerDetailsForm.get('date')?.invalid) {
                    <mat-error>
                      Date of birth is required
                    </mat-error>
                  }
                </mat-form-field>
              </p>
            </div>
            <div class="col-md-6">

              <p>
                <mat-form-field appearance="outline">
                  <mat-label>Email</mat-label>
                  <input data-testid="customer-email" formControlName="email" type="email" matInput placeholder="Email address">
                  @if (customerDetailsForm.get('email')?.invalid) {
                    <mat-error>
                      Email is required
                    </mat-error>
                  }
                </mat-form-field>
              </p>

              <p>
                <mat-form-field appearance="outline">
                  <mat-label>Alternative email</mat-label>
                  <input data-testid="customer-alt-email" formControlName="emailAlt" type="email" matInput placeholder="Email address">
                  @if (customerDetailsForm.get('emailAlt')?.invalid) {
                    <mat-error>
                      Alternative email is invalid
                    </mat-error>
                  }
                </mat-form-field>
              </p>

              <p>
                <mat-form-field appearance="outline">
                  <mat-label>Your Phone Number</mat-label>
                  <input data-testid="customer-phone-number" formControlName="phoneNumber" matInput placeholder="Phone Number">
                  @if (customerDetailsForm.get('phoneNumber')?.invalid) {
                    <mat-error>
                      Phone number is required
                    </mat-error>
                  }
                </mat-form-field>
              </p>
              <p>
                <mat-form-field appearance="outline">
                  <mat-label>Alternative Phone Number</mat-label>
                  <input data-testid="customer-alternative-phone-number" formControlName="alternativeNumber" matInput placeholder="Phone Number">
                  @if (customerDetailsForm.get('alternativeNumber')?.invalid) {
                    <mat-error>
                      Phone Number is invalid
                    </mat-error>
                  }
                </mat-form-field>
              </p>
              <p>
                <mat-form-field appearance="outline">
                  <mat-label>Who is this prescription for?</mat-label>
                  <mat-select data-testid="customer-for-who" formControlName="forWho">
                    @for (option of forWhoOptions; track option) {
                      <mat-option [value]="option">
                        {{option}}
                      </mat-option>
                    }
                  </mat-select>
                  @if (customerDetailsForm.get('forWho')?.invalid) {
                    <mat-error>
                      Select who is this for
                    </mat-error>
                  }
                </mat-form-field>
              </p>
            </div>
          </div>
          <div class="text-end">
            <button data-testid="next-step" [disabled]="!customerDetailsForm.valid" class='mx-1' color="primary" mat-raised-button
              matStepperNext>
              <mat-icon>chevron_right</mat-icon> Next
            </button>
          </div>
        </form>
      </mat-step>
      @if ((customerDetailsForm.value.forWho===ForWho.Me || customerDetailsForm.value.forWho===ForWho.Company)) {
        <mat-step
          [stepControl]="selfForm" [editable]="isEditable">
          <ng-template matStepLabel>Prescription details</ng-template>
          <form autocomplete="off" class='mt-1' [formGroup]="selfForm">
            <div class="row">
              <div class="col-md-6">
                <p>
                  <mat-form-field appearance="outline">
                    <mat-label>Number Of Dependants</mat-label>
                    <input data-testid="self-number-of-dependants" type="number" min="1" formControlName="numberOfDependants" matInput
                      placeholder="Number of Dependants">
                      @if (selfForm.get('numberOfDependants')?.invalid) {
                        <mat-error>
                          Number of dependants is required
                        </mat-error>
                      }
                    </mat-form-field>
                  </p>
                  <p>
                    <mat-form-field appearance="outline">
                      <mat-label>Search for a country</mat-label>
                      <input [disabled]="isLoading" type="text" placeholder="Search for an address" aria-label="Search for a country" matInput formControlName="country" [matAutocomplete]="auto">
                      <mat-autocomplete autoActiveFirstOption #auto="matAutocomplete">
                        @for (country of filteredCountries | async; track country) {
                          <mat-option [value]="country.name">
                            {{country.name}}
                          </mat-option>
                        }
                      </mat-autocomplete>
                      <mat-icon matPrefix>search</mat-icon>
                      @if (selfForm.get('country')?.invalid) {
                        <mat-error>
                          Country is required
                        </mat-error>
                      }
                    </mat-form-field>
                  </p>
                  <p>
                    <mat-form-field appearance="outline">
                      <mat-label>Province</mat-label>
                      <mat-select data-testid="self-province" formControlName="province">
                        @for (province of provinces; track province) {
                          <mat-option value="{{province.name}}">
                            {{province.name}}
                          </mat-option>
                        }
                      </mat-select>
                      @if (selfForm.get('province')?.invalid) {
                        <mat-error>
                          Province is required
                        </mat-error>
                      }
                    </mat-form-field>
                  </p>
                  <p>
                    <mat-form-field appearance="outline">
                      <mat-label>Address Line 1</mat-label>
                      <input data-testid="self-address-line-1" formControlName="addressLine1" matInput placeholder="Address Line 1">
                      @if (selfForm.get('addressLine1')?.invalid) {
                        <mat-error>
                          Address Line 1 is required
                        </mat-error>
                      }
                    </mat-form-field>
                  </p>
                </div>
                <div class="col-md-6">
                  <p>
                    <mat-form-field appearance="outline">
                      <mat-label>Address Line 2</mat-label>
                      <input data-testid="self-address-line-2" formControlName="addressLine2" matInput placeholder="Address Line 2">
                      @if (selfForm.get('addressLine2')?.invalid) {
                        <mat-error>
                          Address Line 2 is invalid
                        </mat-error>
                      }
                    </mat-form-field>
                  </p>
                  <p>
                    <mat-form-field appearance="outline">
                      <mat-label>Building Number</mat-label>
                      <input data-testid="self-building-apt-number" type="number" min="1" formControlName="buildingAptNumber" matInput
                        placeholder="Building Number">
                        @if (selfForm.get('buildingAptNumber')?.invalid) {
                          <mat-error>
                            Building number is required
                          </mat-error>
                        }
                      </mat-form-field>
                    </p>
                    <p>
                      <mat-form-field appearance="outline">
                        <mat-label>Postcode</mat-label>
                        <input data-testid="self-postcode" formControlName="postcode" matInput placeholder="Postcode">
                        @if (selfForm.get('postcode')?.invalid) {
                          <mat-error>
                            Postcode is required
                          </mat-error>
                        }
                      </mat-form-field>
                    </p>
                    <p>
                      <mat-form-field appearance="outline">
                        <mat-label>Select method of delivery</mat-label>
                        <mat-select data-testid="self-delivery-type" #chosenValue formControlName="deliveryType">
                          @for (type of deliveryTypes; track type) {
                            <mat-option value="{{type.id}}">
                              {{type.type}}
                            </mat-option>
                          }
                        </mat-select>
                        @if (selfForm.get('deliveryType')?.invalid) {
                          <mat-error>
                            Method of delivery is required
                          </mat-error>
                        }
                      </mat-form-field>
                    </p>
                  </div>
                </div>
                <div class="text-end">
                  <button data-testid="previous-step" class="mx-1" color="primary" mat-raised-button matStepperPrevious>
                    <mat-icon>chevron_left</mat-icon> Back
                  </button>
                  @if (customerDetailsForm.value.forWho===ForWho.Company) {
                    <button data-testid="next-step" [disabled]="!selfForm.valid"
                      class="mx-1" color="primary" mat-raised-button matStepperNext>
                      <mat-icon>chevron_right</mat-icon> Next
                    </button>
                  }
                  @if (customerDetailsForm.value.forWho===ForWho.Me) {
                    <button data-testid="save-button" [disabled]="!selfForm.valid"
                      class="mx-1" color="primary" mat-raised-button (click)="submitPrescription()">
                      <mat-icon>save</mat-icon> Save
                    </button>
                  }
                </div>
              </form>
            </mat-step>
          }
          @if (customerDetailsForm.value.forWho===ForWho.Company) {
            <mat-step [editable]="isEditable">
              <ng-template matStepLabel>Company details</ng-template>
              <form autocomplete="off" [formGroup]="companyPrescriptionDetailsForm">
                <div class="row">
                  <div class="col-md-6">
                    <p>
                      <mat-form-field appearance="outline">
                        <mat-label>Company name</mat-label>
                        <input data-testid="company-name" formControlName="companyName" matInput placeholder="Company name">
                        @if (companyPrescriptionDetailsForm.get('companyName')?.invalid) {
                          <mat-error>
                            Company name is required
                          </mat-error>
                        }
                      </mat-form-field>
                    </p>
                    <p>
                      <mat-form-field appearance="outline">
                        <mat-label>Email address</mat-label>
                        <input data-testid="company-email" formControlName="email" matInput placeholder="Email address">
                        @if (companyPrescriptionDetailsForm.get('email')?.invalid) {
                          <mat-error>
                            Email address is required
                          </mat-error>
                        }
                      </mat-form-field>
                    </p>
                    <p>
                      <mat-form-field appearance="outline">
                        <mat-label>Alternative email address</mat-label>
                        <input data-testid="company-email-alt" formControlName="emailAlt" matInput placeholder="Email address">
                        @if (companyPrescriptionDetailsForm.get('emailAlt')?.invalid) {
                          <mat-error>
                            Alternative email address is not valid
                          </mat-error>
                        }
                      </mat-form-field>
                    </p>
                    <p>
                      <mat-form-field appearance="outline">
                        <mat-label>Phone number</mat-label>
                        <input data-testid="company-phone-number" formControlName="phoneNumber" matInput placeholder="Phone number">
                        @if (companyPrescriptionDetailsForm.get('phoneNumber')?.invalid) {
                          <mat-error>
                            Phone number is required
                          </mat-error>
                        }
                      </mat-form-field>
                    </p>
                    <p>
                      <mat-form-field appearance="outline">
                        <mat-label>Alternative phone number</mat-label>
                        <input data-testid="company-alternative-phone-number" formControlName="phoneNumberAlt" matInput
                          placeholder="Alternative phone number">
                          @if (companyPrescriptionDetailsForm.get('phoneNumberAlt')?.invalid) {
                            <mat-error>
                              Alternative phone number is not valid
                            </mat-error>
                          }
                        </mat-form-field>
                      </p>
                      <p>
                        <mat-form-field appearance="outline">
                          <mat-label>Practice number</mat-label>
                          <input data-testid="company-practice-number" formControlName="practiceNumber" matInput placeholder="Practice number">
                          @if (companyPrescriptionDetailsForm.get('practiceNumber')?.invalid) {
                            <mat-error>
                              Practice number is required
                            </mat-error>
                          }
                        </mat-form-field>
                      </p>
                      <p>
                        <mat-form-field appearance="outline">
                          <mat-label>VAT registration number</mat-label>
                          <input data-testid="company-vat-reg-number" formControlName="vatRegistrationNumber" matInput
                            placeholder="VAT registration number">
                            @if (companyPrescriptionDetailsForm.get('vatRegistrationNumber')?.invalid) {
                              <mat-error
                                >
                                VAT registration number is required
                              </mat-error>
                            }
                          </mat-form-field>
                        </p>
                      </div>
                      <div class="col-md-6">
                        <p>
                          <mat-form-field appearance="outline">
                            <mat-label>Company type</mat-label>
                            <mat-select data-testid="company-type" formControlName="companyType">
                              @for (type of companyTypes; track type) {
                                <mat-option [value]="type.id">
                                  {{type.type}}
                                </mat-option>
                              }
                            </mat-select>
                            @if (companyPrescriptionDetailsForm.get('companyType')?.invalid) {
                              <mat-error>
                                Select company type
                              </mat-error>
                            }
                          </mat-form-field>
                        </p>
                        <p>
                          <mat-form-field appearance="outline">
                            <mat-label>Search for a country</mat-label>
                            <input [disabled]="isLoading" type="text" placeholder="Search for an address" aria-label="Search for a country" matInput formControlName="country" [matAutocomplete]="auto">
                            <mat-autocomplete autoActiveFirstOption #auto="matAutocomplete">
                              @for (country of filteredCountriesForCompany  | async; track country) {
                                <mat-option [value]="country.name">
                                  {{country.name}}
                                </mat-option>
                              }
                            </mat-autocomplete>
                            <mat-icon matPrefix>search</mat-icon>
                            @if (companyPrescriptionDetailsForm.get('country')?.invalid) {
                              <mat-error>
                                Country is required
                              </mat-error>
                            }
                          </mat-form-field>
                        </p>
                        <p>
                          <mat-form-field appearance="outline">
                            <mat-label>Province</mat-label>
                            <mat-select data-testid="company-province" formControlName="province">
                              @for (province of provinces; track province) {
                                <mat-option value="{{province.name}}">
                                  {{province.name}}
                                </mat-option>
                              }
                            </mat-select>
                            @if (companyPrescriptionDetailsForm.get('province')?.invalid) {
                              <mat-error>
                                Province is required
                              </mat-error>
                            }
                          </mat-form-field>
                        </p>
                        <p>
                          <mat-form-field appearance="outline">
                            <mat-label>Address line 1</mat-label>
                            <input data-testid="company-address-line-1" formControlName="addressLine1" matInput placeholder="Address Line 1">
                            @if (companyPrescriptionDetailsForm.get('addressLine1')?.invalid) {
                              <mat-error>
                                Address Line 1 is required
                              </mat-error>
                            }
                          </mat-form-field>
                        </p>
                        <p>
                          <mat-form-field appearance="outline">
                            <mat-label>Address line 2</mat-label>
                            <input data-testid="company-address-line-2" formControlName="addressLine2" matInput placeholder="Address Line 2">
                            @if (companyPrescriptionDetailsForm.get('addressLine2')?.invalid) {
                              <mat-error>
                                Address Line 2 is invalid
                              </mat-error>
                            }
                          </mat-form-field>
                        </p>
                        <p>
                          <mat-form-field appearance="outline">
                            <mat-label>Building Number</mat-label>
                            <input data-testid="company-building-apt-number" formControlName="buildingAptNumber" type="number" min="1" matInput
                              placeholder="Building Number">
                              @if (companyPrescriptionDetailsForm.get('buildingAptNumber')?.invalid) {
                                <mat-error>
                                  Building Number is required
                                </mat-error>
                              }
                            </mat-form-field>
                          </p>
                          <p>
                            <mat-form-field appearance="outline">
                              <mat-label>Postcode</mat-label>
                              <input data-testid="company-postcode" formControlName="postcode" matInput placeholder="Postcode">
                              @if (companyPrescriptionDetailsForm.get('postcode')?.invalid) {
                                <mat-error>
                                  Postcode is required
                                </mat-error>
                              }
                            </mat-form-field>
                          </p>
                        </div>
                      </div>
                      <div class='text-end'>
                        <button class='mx-1' data-testid="previous-step" color="primary" mat-raised-button matStepperPrevious>
                          <mat-icon>chevron_left</mat-icon> Back
                        </button>
                        <button data-testid="save-button" [disabled]="!companyPrescriptionDetailsForm.valid" class='mx-1' color="primary"
                          mat-raised-button (click)="submitPrescription()">
                          <mat-icon>save</mat-icon> Save
                        </button>
                      </div>
                    </form>
                  </mat-step>
                }
                @if (customerDetailsForm.value.forWho===ForWho.SomeOneElse) {
                  <mat-step [editable]="isEditable">
                    <ng-template matStepLabel>Prescription details</ng-template>
                    <form autocomplete="off"  [formGroup]="individualPrescriptionDetailsForm">
                      <div class="row">
                        <div class="col-md-6">
                          <p>
                            <mat-form-field appearance="outline">
                              <mat-label>Title</mat-label>
                              <mat-select data-testid="individual-title" formControlName="title">
                                <mat-option value="Mr">Mr</mat-option>
                                <mat-option value="Mrs">Mrs</mat-option>
                                <mat-option value="Miss">Miss</mat-option>
                                <mat-option value="Prof">Prof</mat-option>
                              </mat-select>
                              @if (individualPrescriptionDetailsForm.get('title')?.invalid) {
                                <mat-error>
                                  Choose from provided options
                                </mat-error>
                              }
                            </mat-form-field>
                          </p>
                          <p>
                            <mat-form-field appearance="outline">
                              <mat-label>Initials</mat-label>
                              <input data-testid="individual-initials" formControlName="initials" matInput placeholder="Initials">
                              @if (individualPrescriptionDetailsForm.get('initials')?.invalid) {
                                <mat-error>
                                  Initials are required
                                </mat-error>
                              }
                            </mat-form-field>
                          </p>
                          <p>
                            <mat-form-field appearance="outline">
                              <mat-label>First Name</mat-label>
                              <input data-testid="individual-first-name" formControlName="firstName" matInput placeholder="First name">
                              @if (individualPrescriptionDetailsForm.get('firstName')?.invalid) {
                                <mat-error>
                                  First Name is required
                                </mat-error>
                              }
                            </mat-form-field>
                          </p>
                          <p>
                            <mat-form-field appearance="outline">
                              <mat-label>Surname</mat-label>
                              <input data-testid="individual-last-name" formControlName="lastName" matInput placeholder="Last name">
                              @if (individualPrescriptionDetailsForm.get('lastName')?.invalid) {
                                <mat-error>
                                  Surname is required
                                </mat-error>
                              }
                            </mat-form-field>
                          </p>
                          <p>
                            <mat-form-field appearance="outline">
                              <mat-label>Gender</mat-label>
                              <mat-select data-testid="individual-gender" formControlName="gender">
                                <mat-option value="male">Male</mat-option>
                                <mat-option value="female">Female</mat-option>
                                <mat-option value="other">Other</mat-option>
                              </mat-select>
                              @if (individualPrescriptionDetailsForm.get('gender')?.invalid) {
                                <mat-error>
                                  Gender is required
                                </mat-error>
                              }
                            </mat-form-field>
                          </p>
                          <p>
                            <mat-form-field appearance="outline">
                              <mat-label>Is an animal?</mat-label>
                              <mat-select data-testid="individual-is-animal" formControlName="isAnimal">
                                <mat-option value="0">No</mat-option>
                                <mat-option value="1">Yes</mat-option>
                              </mat-select>
                              @if (individualPrescriptionDetailsForm.get('isAnimal')?.invalid) {
                                <mat-error>
                                  Required
                                </mat-error>
                              }
                            </mat-form-field>
                          </p>
                          <p>
                            <mat-form-field appearance="outline">
                              <mat-label>Date of birth</mat-label>
                              <input data-testid="individual-date-of-birth" formControlName="dateOfBirth" matInput [matDatepicker]="picker1">
                              <mat-datepicker-toggle matSuffix [for]="picker1"></mat-datepicker-toggle>
                              <mat-datepicker #picker1></mat-datepicker>
                              @if (individualPrescriptionDetailsForm.get('date')?.invalid) {
                                <mat-error>
                                  Date of birth is required
                                </mat-error>
                              }
                            </mat-form-field>
                          </p>
                          <p>
                            <mat-form-field appearance="outline">
                              <mat-label>Phone number</mat-label>
                              <input data-testid="individual-phone-number" formControlName="phoneNumber" matInput placeholder="Phone Number">
                              @if (individualPrescriptionDetailsForm.get('phoneNumber')?.invalid) {
                                <mat-error>
                                  Phone number is invalid
                                </mat-error>
                              }
                            </mat-form-field>
                          </p>
                          <p>
                            <mat-form-field appearance="outline">
                              <mat-label> Alternative phone nnumber</mat-label>
                              <input data-testid="individual-alt-number" formControlName="phoneNumberAlt" matInput placeholder="Alternative phone number">
                              @if (individualPrescriptionDetailsForm.get('phoneNumberAlt')?.invalid) {
                                <mat-error>
                                  Alternative phone number is invalid
                                </mat-error>
                              }
                            </mat-form-field>
                          </p>
                          <p>
                            <mat-form-field appearance="outline">
                              <mat-label> Email</mat-label>
                              <input data-testid="individual-email" formControlName="email" type="email" matInput placeholder="Email address">
                              @if (individualPrescriptionDetailsForm.get('email')?.invalid) {
                                <mat-error>
                                  Email  is invalid
                                </mat-error>
                              }
                            </mat-form-field>
                          </p>
                        </div>
                        <div class="col-md-6">
                          <p>
                            <mat-form-field appearance="outline">
                              <mat-label> Alternative email address</mat-label>
                              <input data-testid="individual-alt-email" formControlName="emailAlt" type="email" matInput placeholder="Alternative email address">
                              @if (individualPrescriptionDetailsForm.get('emailAlt')?.invalid) {
                                <mat-error>
                                  Email  is invalid
                                </mat-error>
                              }
                            </mat-form-field>
                          </p>
                          <p>
                            <mat-form-field appearance="outline">
                              <mat-label>Number Of Dependants</mat-label>
                              <input data-testid="individual-number-of-dependants" type="number" min="1" formControlName="numberOfDependants" matInput
                                placeholder="Number of Dependants">
                                @if (individualPrescriptionDetailsForm.get('numberOfDependants')?.invalid) {
                                  <mat-error
                                    >
                                    Number of dependants is required
                                  </mat-error>
                                }
                              </mat-form-field>
                            </p>
                            <p>
                              <mat-form-field appearance="outline">
                                <mat-label>Search for a country</mat-label>
                                <input [disabled]="isLoading" type="text" placeholder="Search for an address" aria-label="Search for a country" matInput formControlName="country" [matAutocomplete]="auto">
                                <mat-autocomplete autoActiveFirstOption #auto="matAutocomplete">
                                  @for (country of filteredCountriesForIndividual  | async; track country) {
                                    <mat-option [value]="country.name">
                                      {{country.name}}
                                    </mat-option>
                                  }
                                </mat-autocomplete>
                                <mat-icon matPrefix>search</mat-icon>
                                @if (individualPrescriptionDetailsForm.get('country')?.invalid) {
                                  <mat-error>
                                    Country is required
                                  </mat-error>
                                }
                              </mat-form-field>
                            </p>
                            <p>
                              <mat-form-field appearance="outline">
                                <mat-label>Province</mat-label>
                                <mat-select data-testid="individual-province" formControlName="province">
                                  @for (province of provinces; track province) {
                                    <mat-option value="{{province.name}}">
                                      {{province.name}}
                                    </mat-option>
                                  }
                                </mat-select>
                                @if (individualPrescriptionDetailsForm.get('province')?.invalid) {
                                  <mat-error>
                                    Province is required
                                  </mat-error>
                                }
                              </mat-form-field>
                            </p>
                            <p>
                              <mat-form-field appearance="outline">
                                <mat-label>Address line 1</mat-label>
                                <input data-testid="individual-address-line-1" formControlName="addressLine1" matInput placeholder="Address Line 1">
                                @if (individualPrescriptionDetailsForm.get('addressLine1')?.invalid) {
                                  <mat-error>
                                    Address Line 1 is required
                                  </mat-error>
                                }
                              </mat-form-field>
                            </p>
                            <p>
                              <mat-form-field appearance="outline">
                                <mat-label>Address line 2</mat-label>
                                <input data-testid="individual-address-line-2" formControlName="addressLine2" matInput placeholder="Address Line 2">
                                @if (individualPrescriptionDetailsForm.get('addressLine2')?.invalid) {
                                  <mat-error>
                                    Address Line 2 is invalid
                                  </mat-error>
                                }
                              </mat-form-field>
                            </p>
                            <p>
                              <mat-form-field appearance="outline">
                                <mat-label>Building Number</mat-label>
                                <input data-testid="individual-building-apt-number" formControlName="buildingAptNumber" type="number" min="1" matInput placeholder="Building Number">
                                @if (individualPrescriptionDetailsForm.get('buildingAptNumber')?.invalid) {
                                  <mat-error
                                    >
                                    Building Number is required
                                  </mat-error>
                                }
                              </mat-form-field>
                            </p>
                            <p>
                              <mat-form-field appearance="outline">
                                <mat-label>Postcode</mat-label>
                                <input data-testid="individual-postcode" formControlName="postcode" matInput placeholder="Postcode">
                                @if (individualPrescriptionDetailsForm.get('postcode')?.invalid) {
                                  <mat-error>
                                    Postcode is required
                                  </mat-error>
                                }
                              </mat-form-field>
                            </p>
                            <p>
                              <mat-form-field appearance="outline">
                                <mat-label>Select method of delivery</mat-label>
                                <mat-select data-testid="individual-delivery-type" #chosenValue formControlName="deliveryType">
                                  @for (type of deliveryTypes; track type) {
                                    <mat-option value="{{type.id}}">
                                      {{type.type}}
                                    </mat-option>
                                  }
                                </mat-select>
                                @if (selfForm.get('deliveryType')?.invalid) {
                                  <mat-error>
                                    Method of delivery is required
                                  </mat-error>
                                }
                              </mat-form-field>
                            </p>
                          </div>
                        </div>
                        <div class="text-end">
                          <button data-testid="previous-step" class="mx-1" color="primary" mat-raised-button matStepperPrevious>
                            <mat-icon>chevron_left</mat-icon> Back
                          </button>
                          <button data-testid="save-button" [disabled]="!individualPrescriptionDetailsForm.valid" class="mx-1" color="primary"
                            mat-raised-button (click)="submitPrescription()">
                            <mat-icon>save</mat-icon> Save
                          </button>
                        </div>
                      </form>
                    </mat-step>
                  }
                  <mat-step [stepControl]="uploadPrescriptionForm" [editable]="isEditable">
                    <ng-template matStepLabel>Upload file from computer</ng-template>
                    <core-file-uploader [accept]="acceptFiles" [uploadButtonText]="'Complete prescription'"
                    (onFileUploaded)="onFileUploaded($event)" [orderId]="orderId"></core-file-uploader>
                  </mat-step>
                </mat-stepper>
              </mat-card>
            </div>